import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button } from '~/components';
import { DownloadIcon } from '~/img';
import colors from '~/constants/colors';
import useDownloadPosReport from './useDownloadPosReport';

interface DownloadReportButtonsProps {
  /** When true, buttons render full-width stacked (for the mobile drawer) */
  fullWidth?: boolean;
}

/**
 * Shared download buttons for Bank Report and TMS Registration Report.
 * Used by both the desktop AgentFilters (inside a Row/Col) and
 * the mobile AgentFiltersButton drawer.
 */
const DownloadReportButtons: React.FC<DownloadReportButtonsProps> = ({ fullWidth = false }) => {
  const { t } = useTranslation('agent');
  const { downloadingReport, handleDownloadPosReport } = useDownloadPosReport();

  return (
    <Wrapper fullWidth={fullWidth}>
      <StyledButton
        id="download-bank-report-btn"
        loading={downloadingReport === 'bank'}
        disabled={downloadingReport !== null && downloadingReport !== 'bank'}
        onClick={() => handleDownloadPosReport('bank')}
        icon={<DownloadIcon />}
        type="default"
        fullWidth={fullWidth}
      >
        {t('Bank Report Download')}
      </StyledButton>
      <StyledButton
        id="download-registration-report-btn"
        loading={downloadingReport === 'registration'}
        disabled={downloadingReport !== null && downloadingReport !== 'registration'}
        onClick={() => handleDownloadPosReport('registration')}
        icon={<DownloadIcon />}
        type="default"
        fullWidth={fullWidth}
      >
        {t('TMS Registration Report Download')}
      </StyledButton>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ fullWidth: boolean }>`
  display: flex;
  flex-direction: ${({ fullWidth }) => (fullWidth ? 'column' : 'row')};
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: ${({ fullWidth }) => (fullWidth ? '16px' : '0')};
`;

const StyledButton = styled(Button) <{ fullWidth: boolean }>`
border: 1.5px solid ${colors.primaryColor} !important;
color: ${colors.primaryColor} !important;
background - color: transparent!important;
border - radius: 8px!important;
font - weight: 600!important;
height: 38px!important;
padding: 0 16px!important;
display: inline - flex!important;
align - items: center!important;
justify - content: center!important;
gap: 8px!important;
margin - bottom: 24px;
width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')} !important;

@media(max - width: 768px) {
  width: 100 % !important;
}

  .anticon {
  color: ${colors.primaryColor} !important;
  font - size: 16px!important;
}

  &: hover,
  &: focus,
  &:active {
  background - color: ${colors.blue[50]} !important;
  border - color: ${colors.blue[900]} !important;
  color: ${colors.blue[900]} !important;
    .anticon {
    color: ${colors.blue[900]} !important;
  }
}

  &:disabled {
  border - color: ${colors.grey[300]} !important;
  color: ${colors.grey[500]} !important;
  background - color: ${colors.grey[100]} !important;
    .anticon {
    color: ${colors.grey[500]} !important;
  }
}
`;

export default DownloadReportButtons;
